import { render, staticRenderFns } from "./PreviewMassiveAssignment.vue?vue&type=template&id=06670a2d&scoped=true&"
import script from "./PreviewMassiveAssignment.vue?vue&type=script&lang=js&"
export * from "./PreviewMassiveAssignment.vue?vue&type=script&lang=js&"
import style0 from "./PreviewMassiveAssignment.vue?vue&type=style&index=0&id=06670a2d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06670a2d",
  null
  
)

export default component.exports